<template>
  <Layout>
    <div class="card top-draft">
      <div class="">
        <!-- <div class="col-lg-12">
          <b-button
            v-if="power['添加']"
            style="margin-right:20px"
            variant="primary"
            @click="addOperator()"
          >
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
          <b-button
            v-if="power['添加']"
            variant="primary"
            @click="createOperator()"
          >
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            创建
          </b-button>
        </div> -->

        <div class="col-lg-12 list-header pad-header-bg clearfix">
          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.content"
              placeholder="请输入搜索内容"
              @keyup.enter.native="search"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.state"
              class="form-select"
              :options="statusOptions"
              type="text"
            ></b-form-select>
          </div>
          <b-button
            v-if="power['添加']"
            style="margin-right:20px"
            variant="primary"
            class="btn-sm"
            @click="addOperator()"
          >
            <i class="bx bx-plus font-size-14 align-middle me-2"></i>
            添加
          </b-button>
          <b-button
            v-if="power['添加']"
            variant="primary"
            class="btn-sm"
            @click="createOperator()"
          >
            <i class="bx bx-plus font-size-14 align-middle me-2"></i>
            创建
          </b-button>
        </div>

        <div class="col-lg-12">
          <div class="table-responsive" v-loading="tableLoading">
            <table
              class="table table-nowrap table-centered table-striped align-middle"
            >
              <thead>
                <tr>
                  <!-- <th scope="col" style="width: 70px;">
                    <b-form-checkbox
                      @change="checkedAll"
                      v-model="indeterminate"
                      checked
                      plain
                    ></b-form-checkbox>
                  </th> -->
                  <th scope="col" style="width: 70px">ID</th>
                  <th scope="col">账号</th>
                  <th scope="col" class="w-300px">姓名</th>
                  <th scope="col" class="w-300px">手机</th>
                  <th scope="col">媒体号角色</th>
                  <th scope="col">状态</th>
                  <th scope="col">创建日期</th>
                  <th scope="col">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in user_list" :key="item.adminId">
                  <!-- <td>
                    <b-form-checkbox
                      v-model="choiceListIds"
                      :value="item.id"
                      checked
                      plain
                    ></b-form-checkbox>
                  </td> -->
                  <td>{{ item.adminId || "--" }}</td>

                  <td class="white-inherit">
                    <div style="width: 200px">{{ item.name || "--" }}</div>
                  </td>
                  <td class="white-inherit">{{ item.userName || "--" }}</td>
                  <td class="white-inherit">{{ item.phone || "--" }}</td>
                  <td class="white-inherit">
                    {{ item.roleName || "--" }}
                  </td>
                  <td>
                    <el-tooltip
                      v-if="power['启用/禁用']"
                      :content="item.state == 0 ? '点击启用' : '点击禁用'"
                    >
                      <span
                        @click="changeStatus(0, item)"
                        v-if="item.state == 1"
                        class="dsply-fix status-open"
                        ><i></i>启用</span
                      >
                      <span
                        @click="changeStatus(1, item)"
                        v-if="item.state == 0"
                        class="dsply-fix status-off"
                        ><i></i>禁用</span
                      >
                    </el-tooltip>
                    <div v-if="!power['启用/禁用']">
                      <span v-if="item.state == 1" class="dsply-fix status-open"
                        ><i></i>启用</span
                      >
                      <span v-if="item.state == 0" class="dsply-fix status-off"
                        ><i></i>禁用</span
                      >
                    </div>
                  </td>
                  <td>{{ item.createdAt || "--" }}</td>
                  <td>
                    <button
                      v-if="power['编辑']"
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toDetail(item)"
                    >
                      编辑
                    </button>

                    <button
                      v-if="power['移除']"
                      type="button"
                      class="btn-sm btn btn-danger"
                      @click="deleteUser(item.adminId, true)"
                    >
                      删除
                    </button>

                    <!-- <ul class="list-inline font-size-20 contact-links mb-0">
                      <li class="list-inline-item px-2" @click="toDetail(item)">
                        <a v-b-tooltip.hover title="编辑">
                          <i class="bx bxs-edit"></i>
                        </a>
                      </li>
                      <li class="list-inline-item px-2" @click="frozenMedia(item)" v-if="item.enable == 0">
                        <a v-b-tooltip.hover title="解冻">
                          <i class="bx bx-upvote"></i>
                        </a>
                      </li>
                      <li class="list-inline-item px-2" @click="unfrozenMedia(item)" v-if="item.enable == 1">
                        <a v-b-tooltip.hover title="冻结">
                          <i class="bx bx-downvote"></i>
                        </a>
                      </li>
                      <li class="list-inline-item px-2" @click="remove(item)">
                        <a v-b-tooltip.hover title="移除">
                          <i class="bx bx-trash"></i>
                        </a>
                      </li>
                    </ul> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="!user_list || !user_list[0]" class="xb-table-noData">
              <span v-if="!tableLoading && !user_list[0]">暂无数据</span>
            </div>
          </div>
          <!-- <pagination
            ref="page"
            @pageCallback="pageCallback"
            v-show="user_list.length"
          ></pagination> -->
          <pagination
            :isBatch="false"
            :total="pageTotal"
            :pageSize="pageParams.pageSize"
            :page.sync="pageParams.page"
            :pageSizes="[10, 20, 30]"
            @pageCallback="pageCallback"
            ref="page"
          ></pagination>
        </div>
      </div>
      <!-- <app-list-loading ref="loading"></app-list-loading> -->
      <!-- <b-modal v-model="detailModal" :title="detailTitle" centered size="lg">
        <div class="col-12 px-5">
          <div class="col-12  pb-4 flex-align-center">
            <div class="col-2 text-end pe-3">运营人员名称</div>
            <div class="col-10">
              <b-input class="col-12" v-model="name"></b-input>
            </div>
          </div>

          <div class="col-12  pb-4 flex">
            <div class="col-2 text-end pe-3">图片</div>
            <div class="col-10">
              <image-upload size="1:1" ref="image"></image-upload>
              <div style="color: #aaa; margin-top: 5px;">
                图片比例 1:1，建议尺寸 600 * 600 px，建议文件小于10MB
              </div>
            </div>
          </div>

          <div class="col-12  pb-4 flex">
            <div class="col-2 text-end pe-3">运营人员简介</div>
            <div class="col-10">
              <b-form-textarea rows="3" v-model="description"></b-form-textarea>
            </div>
          </div>

          <div class="col-12  pb-4 flex">
            <div class="col-2 text-end pe-3">媒体号</div>
            <div class="col-10">
              <span class="pe-2" v-if="mediaName !== ''">{{ mediaName }}</span>
              <b-button
                variant="primary"
                class="px-3 py-1"
                pill
                @click="selectMedia"
                >选择</b-button
              >
            </div>
          </div>

          <div class="col-12  pb-4 flex">
            <div class="col-2 text-end pe-3">状态</div>
            <div class="col-10">
              <b-form-radio-group plain v-model="state">
                <b-form-radio :value="0">显示</b-form-radio>
                <b-form-radio :value="1">隐藏</b-form-radio>
              </b-form-radio-group>
            </div>
          </div>
        </div>

        <template #modal-footer>
          <b-button
            variant="outline-primary"
            @click="detailModal = false"
            style="margin-right:10px"
            >取消</b-button
          ><b-button variant="primary" @click="saveUser">确认</b-button>
        </template>
      </b-modal> -->

      <el-dialog
        :title="detailTitle"
        :visible.sync="detailModal"
        class="top-draft-dialog"
        append-to-body
        :before-close="closeCreateModal"
        width="600px"
      >
        <div class="col-12 px-5">
          <div class="col-12 pb-4 flex-align-center">
            <div class="col-3 text-end pe-3">账号</div>
            <div class="col-9">
              {{ name }}
            </div>
          </div>

          <div class="col-12 pb-4 flex flex-align-center">
            <div class="col-3 text-end pe-3">媒体号角色</div>
            <div class="col-9">
              <b-form-select
                v-model="roleId"
                class="form-select"
                :options="roleOptions"
                type="text"
              ></b-form-select>
            </div>
          </div>

          <div class="col-12 pb-4 flex">
            <div class="col-3 text-end pe-3">启用状态</div>
            <div class="col-9">
              <b-form-radio-group plain v-model="state">
                <b-form-radio :value="1">启用</b-form-radio>
                <b-form-radio :value="0">禁用</b-form-radio>
              </b-form-radio-group>
            </div>
          </div>
        </div>

        <div class="xb-footer">
          <b-button
            variant="outline-primary"
            @click="detailModal = false"
            style="margin-right: 20px"
            class="pd-rl-1"
            >取消</b-button
          ><b-button variant="primary" class="pd-rl-1" @click="saveUser"
            >确认</b-button
          >

          <!-- <button
            class="btn-sm btn btn-outline-dark"
            type="button"
            style="margin-right:20px"
            @click="detailModal = false"
          >
            取消
          </button>
          <button
            class="btn-sm btn btn-primary"
            type="button"
            @click="saveUser"
          >
            确定
          </button> -->
        </div>
      </el-dialog>

      <media-dialog @pageCallback="pageCallback" ref="media"></media-dialog>

      <admin-dialog
        @change="addUser"
        ref="operator"
        :visible="addModal"
      ></admin-dialog>

      <!-- <img-detail ref="imgDetail"></img-detail> -->
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import mediaApi from "@/server/api/media";
import Layout from "@/router/layouts/main";
import imageUpload from "@/components/imageUpload";
import mediaDialog from "@/components/choseMedia/mediaDialog.vue";
import adminDialog from "./adminDialog.vue";
import roleApi from "@/server/api/roles";
import { changeList } from "@/util/fun.js";
import { addCache, updateCache } from "@/util/localAche.js";
/**
 * Contacts-list component
 */
export default {
  components: {
    Layout,
    imageUpload,
    mediaDialog,
    adminDialog,
  },

  data() {
    return {
      roleOptions: [],
      id: undefined,
      pageTotal: 0,
      page: 1,
      pageSize: 10,
      detailTitle: "新建",
      power: "",
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 10,
        mediaId: undefined,
        state: "", //1启用2禁用
        content: "",
      },
      user_list: [],
      statusOptions: [
        { text: "筛选状态", value: "" },
        // { text: "普通用户", value: "0" },
        { text: "启用", value: 1 },
        { text: "冻结", value: 0 },
        // { text: "运营用户", value: "3" },
      ],
      stateList: [
        { text: "全部状态", value: "" },
        { text: "未审核", value: 0 },
        { text: "通过", value: 1 },
        { text: "未通过", value: 2 },
      ],
      showDetail: false,
      dialogItem: {},
      detailModal: false,
      batchs: [
        { text: "批量操作", value: "0" },
        { text: "启用", value: "启用" },
        { text: "隐藏", value: "隐藏" },
        { text: "移除", value: "移除" },
      ],
      name: "",
      mediaId: undefined,
      mediaName: "",
      state: 0, //启用状态 0-启用,1禁用
      roleId: "",
      adminId: undefined,
      roleName: "",
      addModal: false,
      showLoading: false,
      tableLoading: true,
    };
  },

  watch: {
    choiceListIds: function() {
      console.log("改变了", this.choiceListIds);
      if (
        this.choiceListIds.length == this.user_list.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (["/createOperator"].indexOf(from.path) == -1) {
      console.log("清空列表缓存");
      //清空列表数据
      updateCache("operator-list", { user_list: "" });
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (["/createOperator"].indexOf(to.path) == -1) {
      console.log("清空列表缓存");
      //清空列表数据
      updateCache("operator-list", { user_list: "" });
    }
    next();
  },
  created() {
    this.pageParams.mediaId = this.mediaId = JSON.parse(
      localStorage.chosedMedia
    ).id;
    this.power = this.utils.currentPower("创作平台-运营人员管理");
    let obj = this.getCache("operator-list");
    if (obj && obj.user_list && obj.user_list[0]) {
      this.user_list = obj.user_list;
      this.pageTotal = obj.pageTotal;
      this.pageParams = obj.pageParams;
      if (obj.roleOptions && obj.roleOptions[0]) {
        this.roleOptions = obj.roleOptions;
      } else {
        this.getRoleList();
      }
      obj = this.getCache("operator-edit");
      this.addCache("operator-edit", "");
      if (obj && obj.changed) {
        this.getList(false);
      }
    } else {
      this.getList();
      this.addCache("operator-edit", "");
    }
  },

  beforeDestroy() {
    this.addCache("operator-list", {
      user_list: this.user_list,
      roleOptions: this.roleOptions,
      pageTotal: this.pageTotal,
      pageParams: this.pageParams,
    });
  },

  methods: {
    addUser(data) {
      if (data === false) {
        this.addModal = false;
        return;
      }
      let params = {
        ids: data,
        mediaId: this.pageParams.mediaId,
      };
      mediaApi.mediaUserAdd(params).then((res) => {
        if (res.code === 0) {
          this.success("添加成功！");
          this.addModal = false;
          this.getList(false);
        } else {
          this.warning(res.msg);
          console.log(res);
        }
      });
    },
    addOperator() {
      // console.log("token", this.cookies.getCookie("token"));
      // this.$refs.operator.showModel();
      this.addModal = true;
    },

    getRoleList() {
      let params = {
        page: 1,
        pageSize: 999,
        type: 2,
        mediaId: this.mediaId,
      };
      roleApi.list(params).then((resp) => {
        if (resp.code == 0) {
          this.roleOptions = [];
          if (resp.data.items) {
            let arr = [];
            resp.data.items.forEach((item) => {
              let obj = {};
              obj.text = item.name;
              obj.value = item.id;
              arr.push(obj);
            });
            arr.unshift({ text: "请选择", value: "" });
            this.roleOptions = arr;
          }
        } else {
        }
      });
    },
    saveUser() {
      let arr = [];
      let obj = {
        id: this.id,
        adminId: this.adminId,
        roleId: this.roleId,
        state: this.state,
      };
      // if (params.roleId === "") {
      //   delete params.roleId;
      // }
      arr.push(obj);
      let params = {
        mediaId: this.mediaId,
        list: arr,
      };
      mediaApi.mediaUserUpdate(params).then((res) => {
        if (res.code === 0) {
          this.success("更改成功！");
          this.getList();
          this.detailModal = false;
        } else {
          this.warning(res.msg);
        }
      });
    },
    selectMedia() {
      this.$refs.media.showModel();
    },
    //给组件的回调
    pageCallback(obj) {
      if (obj.code == "media") {
        this.mediaId = obj.item.id;
        this.mediaName = obj.item.name;
        return;
      }
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        if (this.choiceListIds.length == 0) {
          Vue.swal("未选择账号");
          return;
        }
        if (obj.batch == "移除") {
          this.confirm("确认移除所选账号？", this.deleteUserBatch);
        }
        if (obj.batch == "启用") {
          this.confirm("确认启用已选账号？", () => {
            this.changeStatus(true);
          });
        }
        if (obj.batch == "禁用") {
          this.confirm("确认禁用已选账号？", () => {
            this.changeStatus(false);
          });
        }
      }
    },

    //更改状态，如果judge存在则item为对象，否则为改为显示或不显示
    changeStatus(state, item) {
      let msg = state ? "确认启用该账号？" : "确认禁用该账号？";
      this.confirm(msg, () => {
        let params = { mediaId: this.mediaId };
        let arr = [];
        if (typeof item !== "boolean") {
          arr.push({
            // id: item.id,
            adminId: item.adminId,
            state: state,
          });
          params.list = arr;
          // params.state = item.state ? 0 : 1;
        } else {
          params.id = this.choiceListIds;
          params.state = item ? 0 : 1;
        }
        mediaApi.mediaUserUpdate(params).then((res) => {
          if (res.code === 0) {
            this.success("更改成功！");
            // this.getList(); 修改状态后不调用列表接口，直接改数据
            this.user_list = changeList(
              "changeAttribute",
              this.user_list,
              [item.adminId],
              {
                state: state ? 1 : 0,
              },
              "adminId"
            );
          } else {
            this.warning(res.msg);
          }
        });
      });
    },
    deleteUser(id) {
      this.confirm("确认移除？", () => {
        this.deleteUserBatch(id);
      });
    },
    deleteUserBatch(id) {
      let params = [{ id: this.pageParams.mediaId, adminId: id }];
      // params.id = this.pageParams.mediaId;
      // params.adminId = id;
      // if (id !== undefined) {
      //   arr.push(id);
      //   params.ids = arr;
      // }
      mediaApi.mediaUserdelete(params).then((res) => {
        if (res.code === 0) {
          this.success("移除成功！");
          this.getList();
          if (id === undefined) {
            this.choiceListIds = [];
          }
        } else {
          this.warning(res.msg);
        }
      });
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.state = "";
      this.pageParams.content = "";
      this.getList();
    },

    // 列表全选
    checkedAll(val) {
      if (val) {
        let ids = [];
        this.user_list.map((item) => {
          ids.push(item.id);
        });
        this.choiceListIds = [];
        this.choiceListIds = ids;
      } else {
        this.choiceListIds = [];
      }
      // if (this.indeterminate) {
      //   this.choiceListIds = this.allListIds;
      // } else {
      //   this.choiceListIds = [];
      // }
    },

    handleClose() {
      this.showDetail = false;
    },

    // 创建
    openCreateModal() {
      this.id = undefined;
      this.detailTitle = "新建";
      this.dataInit();
      this.detailModal = true;
    },
    closeCreateModal() {
      this.detailModal = false;
    },
    dataInit() {
      this.id = undefined;
      this.roleName = "";
      this.state = 1;
    },
    // 编辑
    toDetail(item) {
      this.name = item.name;
      this.detailTitle = "编辑";
      this.dataInit();
      this.id = item.id;
      this.adminId = item.adminId;
      this.roleId = item.roleId;
      this.roleName = item.roleName;
      this.state = item.state;
      this.detailModal = true;
    },
    toContent(item) {
      this.$router.push({
        name: "groupContent",
        query: { id: item.id },
      });
    },
    remove(item) {
      this.confirm("确认删除？", () => {
        let params = {};
        if (item) {
          let arr = [];
          arr.push(item.id);
          params.ids = arr;
        } else {
          params.ids = this.choiceListIds;
        }
        mediaApi.mediaUserdelete(params).then((resp) => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "删除成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            // this.getList(); 删除数据时不调用列表接口,直接从列表删除对应内容
            if (this.items.length == params.ids.length) {
              this.getList();
            } else {
              this.pageTotal -= params.ids.length;
              this.user_list = changeList(
                "delete",
                this.user_list,
                params.ids,
                "id"
              );
              if (!item) {
                this.choiceListIds = [];
              }
            }
          }
        });
      });
    },
    //获取运营人员列表
    getList(showLoading) {
      if (showLoading !== false) {
        this.tableLoading = true;
        this.user_list = [];
      }
      let params = this.another(this.pageParams);
      params.mediaId = this.mediaId;
      this.cleanObj(params);
      this.showLoading = true;
      mediaApi.mediaUserList(params).then((res) => {
        if (res.code === 0) {
          this.tableLoading = false;
          res.data.items.forEach((item) => (item.id = item.adminId));
          this.user_list = res.data.items;
          this.pageTotal = res.data.total;
        }
      });
    },
    //显示审核状态
    showState(state) {
      if (state === 0) {
        return "待审核";
      } else if (state === 1) {
        return "通过";
      } else if (state === 2) {
        return "驳回";
      } else {
        return "未知";
      }
    },
    //显示图片原图
    showImg(url) {
      // this.$refs.imgDetail.showModal(url);
      this.ShowImg(url);
    },
    //创建运营人员
    createOperator() {
      this.$router.push({
        name: "createOperator",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.tag-dialog .el-dialog {
  width: 30%;
}
.tag-dialog .el-dialog__body {
  padding-bottom: 0px;
}
.tag-dialog .main {
  padding-bottom: 24px;
}
</style>
